import { useConfirmKey } from '@/injectionKeys';
import { SHOULD_SHOW_CONFIRM, stateFactory } from '@/utils/state';

export const useBaseConfirm = () => {
  const shouldShowConfirm = stateFactory.create<boolean>(SHOULD_SHOW_CONFIRM, false);

  const setShouldShowConfirm = (flg: boolean) => {
    shouldShowConfirm.value = flg;
  };

  return { shouldShowConfirm, setShouldShowConfirm };
};

export const useConfirm = () => {
  const injectedUseConfirm = inject(useConfirmKey) as typeof useBaseConfirm;
  return injectedUseConfirm();
};
